import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Additifs',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acésulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'Esculine',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyane',
    [ProductAdditives.Antioxidant]: 'Antioxydant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxydant : Acide ascorbique',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxydant : Tocophérols',
    [ProductAdditives.Flavor]: 'Arôme',
    [ProductAdditives.Flavors]: 'Arômes',
    [ProductAdditives.AscorbicAcid]: 'Acide ascorbique',
    [ProductAdditives.Aspartame]: 'Aspartame',
    [ProductAdditives.OysterSauce]: 'Sauce aux huîtres',
    [ProductAdditives.BakingAid]: 'Aide à la cuisson',
    [ProductAdditives.BakingPowder]: 'Levure chimique',
    [ProductAdditives.BalsamicVinegar]: 'Vinaigre balsamique',
    [ProductAdditives.BalsamicCream]: 'Crème balsamique',
    [ProductAdditives.BasilPesto]: 'Pesto au basilic',
    [ProductAdditives.BenzoicAcid]: 'Acide benzoïque',
    [ProductAdditives.BetaCarotene]: 'Bêta-carotène',
    [ProductAdditives.Betain]: 'Bétaïne',
    [ProductAdditives.BeetrootRed]: 'Rouge de betterave',
    [ProductAdditives.Beeswax]: "Cire d'abeille",
    [ProductAdditives.Bitters]: 'Amers',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Sirop de Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Vinaigre de brandy',
    [ProductAdditives.Broth]: 'Bouillon',
    [ProductAdditives.Caffeine]: 'Caféine',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Caramel',
    [ProductAdditives.CaramelColor]: 'Colorant caramel',
    [ProductAdditives.CaramelE150d]: 'Caramel E150d',
    [ProductAdditives.Carotene]: 'Carotène',
    [ProductAdditives.CayennePepper]: 'Poivre de Cayenne',
    [ProductAdditives.Chili]: 'Piment',
    [ProductAdditives.ChiliDressing]: 'Vinaigrette au chili',
    [ProductAdditives.ChiliMayonnaise]: 'Mayonnaise au chili',
    [ProductAdditives.ChiliOil]: 'Huile de chili',
    [ProductAdditives.Quinine]: 'Quinine',
    [ProductAdditives.Chlorophyll]: 'Chlorophylle',
    [ProductAdditives.CitricAcid]: 'Acide citrique',
    [ProductAdditives.CitrusAcid]: "Acide d'agrumes",
    [ProductAdditives.CarbonDioxide]: 'Dioxyde de carbone (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Sauce cocktail',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pâte de curry',
    [ProductAdditives.CurryPowder]: 'Poudre de curry',
    [ProductAdditives.CurryCreamSauce]: 'Sauce curry à la crème',
    [ProductAdditives.Fragrance]: 'Arôme',
  },
};
